module.exports = __webpack_public_path__ + "static/0027-a7c9a7a3dc4f7c578aa2294728ee7dad.png";